import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, NavLink, Navigate, useNavigate, useLocation } from 'react-router-dom';
import './App.css';
import ThesisMarketsPage from './news/ThesisMarketsPage';
import EnginePage from './news/EnginePage';
import JobsLayout from './jobs/JobsLayout';
import MusicLayout from './music/MusicLayout';
import MusicPlayer from './music/MusicPlayer';
import MobileHeader from './components/MobileHeader';
import { PlayerProvider } from './music/PlayerContext';
import { AuthProvider, useAuth } from './auth/AuthContext';
import AccountPage from './auth/AccountPage';

function AppInner() {
  const navigate = useNavigate();
  const location = useLocation();
  const marketsActive = location.pathname.startsWith('/markets');

  const [jobIndustryFilter, setJobIndustryFilter] = useState([]);
  const [jobRoleFilter, setJobRoleFilter] = useState([]);

  const handleNavigateToJobs = (filters = {}) => {
    setJobIndustryFilter(filters.industries || []);
    setJobRoleFilter(filters.roles || []);
    navigate('/jobs/roles');
  };

  const { user } = useAuth();

  return (
    <div className="App">
      <MobileHeader onJobsClick={() => { setJobIndustryFilter([]); setJobRoleFilter([]); }} />

      <div className="app-top-bar">
        <div className="app-logo">ferl</div>
        <MusicPlayer accountLink={
          <NavLink to="/account" className={`app-tabs-account${location.pathname.startsWith('/account') ? ' active' : ''}`}>
            <svg className="app-account-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="8" r="4"/>
              <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/>
            </svg>
            <span className="app-tabs-account-label">{user ? user.username : 'Sign in'}</span>
          </NavLink>
        } />
      </div>

      <div className="app-body">
        <nav className="app-sidebar">
          <NavLink
            to="/jobs"
            className={location.pathname.startsWith('/jobs') ? 'active' : ''}
            onClick={() => { setJobIndustryFilter([]); setJobRoleFilter([]); }}
          >Jobs</NavLink>
          <NavLink
            to="/music/playlist"
            className={location.pathname.startsWith('/music') ? 'active' : ''}
          >Music</NavLink>
          <NavLink to="/markets" className={marketsActive ? 'active' : ''}>Markets</NavLink>
        </nav>

        <main className="app-content">
          <Routes>
            <Route path="/" element={<Navigate to="/markets" replace />} />

            <Route path="/markets" element={<ThesisMarketsPage />} />
            <Route path="/markets/engine" element={<EnginePage />} />

            <Route path="/jobs/*" element={
              <JobsLayout
                selectedIndustries={jobIndustryFilter}
                setSelectedIndustries={setJobIndustryFilter}
                selectedRoles={jobRoleFilter}
                setSelectedRoles={setJobRoleFilter}
              />
            } />

            <Route path="/music/*" element={<MusicLayout />} />

            {/* Legacy redirects */}
            <Route path="/paper" element={<Navigate to="/markets" replace />} />
            <Route path="/paper/markets" element={<Navigate to="/markets" replace />} />
            <Route path="/paper/*" element={<Navigate to="/markets" replace />} />

            <Route path="/account" element={
              <AccountPage onNavigateToJobs={handleNavigateToJobs} />
            } />

            <Route path="*" element={<Navigate to="/markets" replace />} />
          </Routes>
        </main>
      </div>

      <nav className="app-mobile-tabs">
        <NavLink to="/jobs" className={location.pathname.startsWith('/jobs') ? 'active' : ''} onClick={() => { setJobIndustryFilter([]); setJobRoleFilter([]); }}>Jobs</NavLink>
        <NavLink to="/music/playlist" className={location.pathname.startsWith('/music') ? 'active' : ''}>Music</NavLink>
        <NavLink to="/markets" className={marketsActive ? 'active' : ''}>Markets</NavLink>
        <NavLink to="/account" className={location.pathname.startsWith('/account') ? 'active' : ''}>Account</NavLink>
      </nav>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PlayerProvider>
          <AppInner />
        </PlayerProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
